/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type NFLOddsReportTableQueryVariables = {||};
export type NFLOddsReportTableQueryResponse = {|
  +whoAmI: ?{|
    +groups: $ReadOnlyArray<{|
      +name: string
    |}>
  |},
  +nflCurrentWeekOdds: ?$ReadOnlyArray<?{|
    +team: ?{|
      +abbreviation: string,
      +name: ?string,
    |},
    +opp: ?{|
      +abbreviation: string,
      +name: ?string,
    |},
    +home: ?boolean,
    +pointSpread: ?string,
    +pointSpreadOdds: ?number,
    +gameTotal: ?string,
    +impliedTeamTotal: ?string,
    +moneylineOdds: ?number,
  |}>,
|};
export type NFLOddsReportTableQuery = {|
  variables: NFLOddsReportTableQueryVariables,
  response: NFLOddsReportTableQueryResponse,
|};
*/


/*
query NFLOddsReportTableQuery {
  whoAmI {
    groups {
      name
    }
    id
  }
  nflCurrentWeekOdds {
    team {
      abbreviation
      name
      id
    }
    opp {
      abbreviation
      name
      id
    }
    home
    pointSpread
    pointSpreadOdds
    gameTotal
    impliedTeamTotal
    moneylineOdds
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "GroupType",
  "kind": "LinkedField",
  "name": "groups",
  "plural": true,
  "selections": [
    (v0/*: any*/)
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviation",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  (v0/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "home",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pointSpread",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pointSpreadOdds",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gameTotal",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "impliedTeamTotal",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "moneylineOdds",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = [
  (v2/*: any*/),
  (v0/*: any*/),
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NFLOddsReportTableQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NFLTeamOddsType",
        "kind": "LinkedField",
        "name": "nflCurrentWeekOdds",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "opp",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NFLOddsReportTableQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NFLTeamOddsType",
        "kind": "LinkedField",
        "name": "nflCurrentWeekOdds",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "opp",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ce655cfdcf3a3280de77bb33a90fe6ea",
    "id": null,
    "metadata": {},
    "name": "NFLOddsReportTableQuery",
    "operationKind": "query",
    "text": "query NFLOddsReportTableQuery {\n  whoAmI {\n    groups {\n      name\n    }\n    id\n  }\n  nflCurrentWeekOdds {\n    team {\n      abbreviation\n      name\n      id\n    }\n    opp {\n      abbreviation\n      name\n      id\n    }\n    home\n    pointSpread\n    pointSpreadOdds\n    gameTotal\n    impliedTeamTotal\n    moneylineOdds\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '55cf4135946edd13e98aa0489e535757';

module.exports = node;
